import { Story } from '@/hooks/useStories';
import { StoryCard } from './StoryCard';

interface StoriesCarouselProps {
  stories: Story[];
  onStoryClick: (index: number) => void;
}

export const StoriesCarousel = ({ stories, onStoryClick }: StoriesCarouselProps) => {
  return (
    <div className="w-full overflow-hidden">
      <div className="flex gap-3 overflow-x-auto pb-4 scrollbar-hide">
        {stories.map((story, index) => (
          <StoryCard
            key={story.id}
            story={story}
            onClick={() => onStoryClick(index)}
          />
        ))}
      </div>
    </div>
  );
};